<template>
        <AuthenticatorSetupOverlay :dark="dark" />
        <CorporateDashboard
        v-if="isCorporatePortal"
        :data="dataCourses"
        :group-courses="groupCourses"
        :hasReady="hasReady"
    />
    <div
        v-else
        class="student-portal-dashboard"
        :class="{ dark: dark }"
    >
        <Banner
            :view="ViewMode"
            :data="dataCourses"
            :bannerPortal="bannerPortal"
            :hasReady="hasReady && bannerReady"
        ></Banner>

        <div class="student-portal-dashboard__inner">
            <KeepWatchingSection v-if="!isPreview" />

            <Content
                :view="ViewMode"
                :data="dataCourses"
                :group-courses="groupCourses"
                :hasReady="hasReady"
                :server-filtered="true"
                @search="onPortalSearch"
            ></Content>
            <div
                v-if="hasReady && totalCatalogPages > 1"
                class="student-portal-dashboard__pagination"
            >
                <v-pagination
                    v-model="catalogPage"
                    :length="totalCatalogPages"
                    :total-visible="5"
                    @update:model-value="onCatalogPageChange"
                />
            </div>
        </div>
    </div>
</template>
<script>
    import apiCourses from '@/utils/portal/course.js';
    import { mapState, mapActions } from 'vuex';
    import { toast } from 'vue3-toastify';

    import Banner from '@/components/Student/Dashboard_Unique/Banner/Banner';
    import Content from '@/components/Student/Dashboard_Unique/Content/Content';
    import KeepWatchingSection from '@/components/Student/Dashboard_Unique/Content/KeepWatchingSection.vue';
    import CorporateDashboard from '@/components/Student/Dashboard_Unique/Corporate/CorporateDashboard.vue';
    import AuthenticatorSetupOverlay from '@/components/Student/Dashboard_Unique/AuthenticatorSetupOverlay.vue';
    import { isPortalCorporateLayout } from '@/utils/corporate/environment';

    export default {
        data() {
            return {
                ViewMode: false,
                dataCourses: null,
                groupCourses: [],
                hasReady: false,
                bannerPortal: null,
                bannerReady: false,
                searchText: '',
                catalogPage: 1,
                catalogSize: 12,
                coursesTotal: 0,
                groupCoursesTotal: 0,
            };
        },
        computed: {
            ...mapState(['token', 'listCoursesPortal', 'dark', 'previewAs', 'websites', 'company']),
            isCorporatePortal() {
                void this.websites;
                void this.company;
                return isPortalCorporateLayout();
            },
            isPreview() {
                return Boolean(this.previewAs?.enabled && this.previewAs.sectorId);
            },
            totalCatalogPages() {
                const total = Math.max(this.coursesTotal, this.groupCoursesTotal);
                return Math.max(1, Math.ceil(total / this.catalogSize));
            },
        },
        methods: {
            ...mapActions(['storeListCouresesPortal']),
            alterarValor(novoValor) {
                this.ViewMode = !this.ViewMode;
            },
            async getDataCourses({ keepPage = false } = {}) {
                try {
                    if (!keepPage) {
                        this.catalogPage = 1;
                    }
                    const catalog = await apiCourses.getDataCourses(
                        this.token,
                        this.buildCatalogParams()
                    );
                    this.storeListCouresesPortal({
                        listCoursesPortal: catalog.courses,
                    });
                    this.dataCourses = catalog.courses || [];
                    this.groupCourses = catalog.groupCourses || [];
                    this.coursesTotal = catalog.coursesTotal || 0;
                    this.groupCoursesTotal = catalog.groupCoursesTotal || 0;
                    this.hasReady = true;
                } catch (error) {
                    const errorMessage = error.response?.data?.message || this.$t('student.courses.loadError');
                    toast.error(errorMessage);
                }
            },
            buildCatalogParams() {
                const search = (this.searchText || '').trim();
                const params = {
                    page: Math.max(this.catalogPage - 1, 0),
                    size: this.catalogSize,
                };
                if (search) {
                    params.search = search;
                }
                if (this.isPreview) {
                    params.previewSectorId = this.previewAs.sectorId;
                    if (this.previewAs.roleId) {
                        params.previewRoleId = this.previewAs.roleId;
                    }
                }
                return params;
            },
            onPortalSearch(term) {
                this.searchText = term || '';
                this.getDataCourses();
            },
            onCatalogPageChange() {
                this.getDataCourses({ keepPage: true });
            },
            async getBannerPortal() {
                this.bannerReady = true;
            },
        },
        watch: {
            ViewMode(novoValor) {
                this.ViewMode = novoValor;
            },
            previewAs: {
                deep: true,
                handler() {
                    this.getDataCourses();
                },
            },
        },
        components: {
            Banner,
            Content,
            KeepWatchingSection,
            CorporateDashboard,
            AuthenticatorSetupOverlay,
        },
        created() {
            this.getDataCourses();
            this.getBannerPortal();
        },
    };
</script>
<style scoped>
    .student-portal-dashboard {
        width: 100%;
        min-width: 0;
        background: var(--dash-bg, #F5F7FA);
        overflow-x: hidden;
    }

    .student-portal-dashboard.dark {
        background: var(--dash-bg, #0f0e12);
    }

    .student-portal-dashboard__inner {
        width: 100%;
        max-width: 1600px;
        margin: 0 auto;
        box-sizing: border-box;
        min-width: 0;
    }

    .student-portal-dashboard__pagination {
        display: flex;
        justify-content: center;
        padding: 8px 16px 32px;
    }

    @media (max-width: 959px) {
        .student-portal-dashboard__inner {
            padding: 0 16px 24px;
        }
    }

    @media (max-width: 480px) {
        .student-portal-dashboard__inner {
            padding: 0 12px 20px;
        }
    }
</style>
